import { ComponentPropsWithoutRef, useState } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { PiEyeLight, PiEyeSlash } from 'react-icons/pi'

import { Input } from '../ui/input'

interface PasswordInputProps extends ComponentPropsWithoutRef<'input'> {
  field?: Partial<ControllerRenderProps>
  showPasswordState?: boolean
}

const PasswordInput = ({
  field,
  showPasswordState,
  ...props
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(showPasswordState ?? false)
  const toggleShowPassword = () => setShowPassword(!showPassword)

  return (
    <div className="relative flex items-center">
      <Input
        placeholder="Insira a senha"
        type={showPassword ? 'text' : 'password'}
        {...field}
        {...props}
      />
      {showPassword ? (
        <PiEyeSlash
          className="absolute right-3 cursor-pointer"
          size={20}
          onClick={toggleShowPassword}
        />
      ) : (
        <PiEyeLight
          className="absolute right-3 cursor-pointer"
          size={20}
          onClick={toggleShowPassword}
        />
      )}
    </div>
  )
}

export default PasswordInput
